import React from 'react'
import { SVGIconProps } from '../types'
const SvgVerticalDistribute = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M22 2v2H2V2zM7 10.5v3h10v-3zM2 20v2h20v-2z" />
  </svg>
)
export default SvgVerticalDistribute
